const executeSingleNormalizer = async (itemModule) => {
  let { normalizer } = itemModule;
  normalizer = await normalizer;
  normalizer = normalizer.default;
  return {
    name: itemModule.name,
    data: normalizer(itemModule.data),
  };
};

const parallelModules = (moduleName, data, orionAlias) => {
  let itemNormalized = null;
  switch (moduleName) {
    case "MODULO_TITLE_SUBTITLE":
    case "MODULO_H1":
      itemNormalized = {
        name: moduleName,
        data,
        normalizer: import("./modules-normalizers/title-normalizer"),
      };
      break;
    case "MODULO_BANNER_CTA":
    case "MODULO_BANNER":
      itemNormalized = {
        name: moduleName,
        data,
        normalizer: import("./modules-normalizers/banner-normalizer"),
      };
      break;
    case "MODULE_SECTION_IMAGE_SLIDER":
      itemNormalized = {
        name: moduleName,
        data,
        normalizer: import("./modules-normalizers/image-slider-normalizer"),
      };
      break;
    case "MODULO_SELECTORES_TV":
    case "MODULO_SELECTOR":
      itemNormalized = {
        name: moduleName,
        data,
        normalizer: import("./modules-normalizers/selector-normalizer"),
      };
      break;
    case "MODULO_CARDS_FINANZAS":
      itemNormalized = {
        name: "MODULO_CARDS_FINANZAS",
        data,
        normalizer: import("./modules-normalizers/distribox-normalizer"),
      };
      break;
    case "MODULO_CARDS_BAF":
    case "MODULO_CARDS_LINEAS_MOVILES":
    case "MODULO_CARDS":
    case "MODULO_CARDS_SEGUROS":
      itemNormalized = {
        name: "MODULO_CARDS",
        data,
        normalizer: import("./modules-normalizers/distribox-normalizer"),
      };
      break;
    case "MODULO_BUYBOX":
      itemNormalized = {
        name: moduleName,
        data,
        normalizer: import("./modules-normalizers/buybox-normalizer"),
      };
      break;
    case "DESCRIPTION_IMG":
      itemNormalized = {
        name: "MODULE_DESCRIPTION_IMG",
        data: data,
        normalizer: import("./modules-normalizers/description-img-normalizer"),
      };
      break;
    case "CARACTERISTICAS_TITLO_DESCRIPTION_HREF_ACTIVAR_ROAMING_V1": 
    itemNormalized = {
      name: "MODULO_TITLEHREF_CONTENT_V1",
      data,
      normalizer: import("./modules-normalizers/titlehref-normalizer"),
    };
    break;
    case "CARACTERISTICAS_TITLO_DESCRIPTION_HREF_ACTIVAR_ROAMING": 
    itemNormalized = {
      name: "MODULO_TITLEHREF_CONTENT",
      data,
      normalizer: import("./modules-normalizers/titlehref-normalizer"),
    };
    break;
    case "TITLE_HREF": 
      itemNormalized = {
        name: "MODULO_TITLEHREF",
        data,
        normalizer: import("./modules-normalizers/titlehref-normalizer"),
      };
      break;
    case "LISTADO_CARACTERISTICS_CARDS": 
      itemNormalized = {
        name: "LISTADO_MODULO_CARACTERISTIC_CARDS",
        data,
        normalizer: import("./modules-normalizers/roaming-characs-normalizer"),
      };
      break;
    case "MODULO_CARDS-MAS-SERVICIOS_TemplateInstance_2cdf8f0b-6952-49b7-9032-2786d2c71c4c_name": 
    case "ZONAS_CONTRATO": 
    case "ZONAS_CONTRATO_copy": 
    case "MODULO_CARDS-DISTRI":
    case "MODULO_CARDS-MAS-SERVICIOS_DISTRI_SERVICIOS_GAMING":
    case "MODULO_CARDS-MAS-SERVICIOS_SALUD":
    case "MODULO_CARDS-MAS-SERVICIOS_SERVICIOS_ENERGIA":
    case "MODULO_CARDS-MAS-SERVICIOS_TEST_VELOCIDAD_CONEXION_SEGURA":
      itemNormalized = {
          name: "MODULO_CARDS",
          data,
          normalizer: import("./modules-normalizers/distris-mas-servicios-normalizer"),
      };
      break;
    case "MODULO_CARDS-MAS-SERVICIOS_SEGURIDAD":
      itemNormalized = {
        name: "MODULO_CARDS",
        data,
        normalizer: import("./modules-normalizers/more-services-normalizer"),
      };
      break;
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRIBUTIVA_SEGURIDAD_PORQUE_ELEGIR_MOVISTAR":
    case "002_LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_INTERNET_ELEGIR_FIBRA":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_TARIFAS_MOVILES_CONTRATO":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_PREPAGO":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_GAMING":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_ENERGIA":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_SEGURO_1":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_QUE_MIDE_ELTEST":
    case "MODULO_LISTADO_CARACTERISTICAS_ICON_TITLE_DESCRIPTION":
      itemNormalized = {
        name: "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION",
        data,
        normalizer: import("./modules-normalizers/districharacs-normalizer"),
      };
      break;
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_TemplateInstance_2b742737-9fc5-LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRIBUTIVA_SEGURIDAD_PORQUE_SERVICIOS_ADICIONALES-980f-c98f6d8d6df9_name":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_SERVICIOS_ADICIONALES_GAMING":

        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_ENERGIA_":
        case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_ENERGIA_":

    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_ENERGIA_":

      itemNormalized = {
        name: "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_02",
        data,
        normalizer: import("./modules-normalizers/districharacs-normalizer"),
      };
      break;
    case "003_LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_CONTRATACION_RAPIDA":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_TARIFAS_MOVILES_CONTRATO_NUMEROS":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_TARIFAS_MOVILES_CONTRATO_NUMEROS_LINEAS_ADICIONALES":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_NUMEROS_DISTRI_PREPAGO":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_FINANZAS_PAGOS_ONLINE":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_DISTRI_SALUD_CONTRATACION_ONLINE":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_TemplateInstance_9918e81d-54d3-44b8-ad63-97654903acfb_name":
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_CONSEJOS_PARA_HACER_TEST":
      itemNormalized = {
        name: "LISTADO_PASOS_ICONO_TITULO_DESCRIPCION",
        data,
        normalizer: import("./modules-normalizers/steplist-normalizer"),
      };
      break;
    case "LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_MOVISTAR_MONEY":
      itemNormalized = {
        name: "LISTADO_PASOS_ICONO_TITULO_DESCRIPCION_02",
        data,
        normalizer: import("./modules-normalizers/steplist-normalizer"),
      };
      break;
    case "MODULO_CARACTERISTIC_CARDS":
    case "MODULO_CARACTERISTICS_CARDS":
      itemNormalized = {
        name: "MODULO_CARACTERISTIC_CARDS",
        data,
        normalizer: import("./modules-normalizers/characs-normalizer"),
      };
      break;
    case "MODULO_RECOMENDACION":
    case "MODULO_CARDS_CONTENIDOS_FILTER":
      itemNormalized = {
        name: moduleName,
        data: { ...data, orionAlias },
        normalizer: import("./modules-normalizers/recom-normalizer"),
      };
      break;
    case "MODULO_VENTA_CRUZADA_OTROS_SERVICIOS":
    case "MODULO_VENTA_CRUZADA":
      itemNormalized = {
        name: moduleName,
        data: { ...data, orionAlias },
        normalizer: import("./modules-normalizers/interest-normalizer"),
      };
      break;
    case "MODULO_CARDS_VENTA_CRUZADA":
      itemNormalized = {
        name: moduleName,
        data: { ...data, orionAlias },
        normalizer: import("./modules-normalizers/safebox-normalizer"),
      };
      break;
    case "FAQS_PREGUNTAS_FRECUENTES_RECOM": 
      itemNormalized = {
        name: "FAQS_PREGUNTAS_FRECUENTES_RECOM",
        data,
        normalizer: import("./modules-normalizers/faqs-normalizer"),
      };
      break;
    case "FAQS_PREGUNTAS_FRECUENTES_FIBRA_600MB_NEW":
    case "FAQS_PREGUNTAS_FRECUENTES":
      itemNormalized = {
        name: "FAQS_PREGUNTAS_FRECUENTES",
        data,
        normalizer: import("./modules-normalizers/faqs-normalizer"),
      };
      break;
    case "COMPONENT_TYPE":
      itemNormalized = {
        name: "COMPONENT_TYPE",
        data,
        normalizer: import("./modules-normalizers/custo-component-normalizer"),
      };
      break;
      case "MODULE_DESCRIPTION_IMG_01": 
        itemNormalized = {
          name: "MODULE_DESCRIPTION_IMG_01",
          data: data,
          normalizer: import("./modules-normalizers/description-img-normalizer"),
        };
        break;
      case "MODULE_DESCRIPTION_IMG_02": 
        itemNormalized = {
          name: "MODULE_DESCRIPTION_IMG_02",
          data: data,
          normalizer: import("./modules-normalizers/description-img-normalizer"),
        };
        break;
    case "MODULE_DESCRIPTION_IMG":
      itemNormalized = {
        name: "MODULE_DESCRIPTION_IMG",
        data: data,
        normalizer: import("./modules-normalizers/description-img-normalizer"),
      };
      break;
    case "MODULO_IMAGENES_CATEGORIA":
    case "MODULO_LISTADO_CONTENIDOS_IMAGENES_EXTRA":
      itemNormalized = {
        name: moduleName,
        data,
        normalizer: import("./modules-normalizers/tv-module-normalizer"),
      };
      break;
    case "MODULO_SIMPLEPHONE":
      itemNormalized = {
        name: "MODULO_SIMPLEPHONE",
        data: data,
        normalizer: import("./modules-normalizers/simple-phone-normalizer"),
      };
      break;
    case "MODULO_SIMPLEPHONE_FICHA":
      itemNormalized = {
        name: "MODULO_SIMPLEPHONE_FICHA",
        data: data,
        normalizer: import("./modules-normalizers/simple-phone-normalizer"),
      };
      break;
    case "MODULO_PACK_CARD":
      itemNormalized = {
        name: moduleName,
        data: { ...data, orionAlias },
        normalizer: import("./modules-normalizers/tv-card-normalizer"),
      };
      break;
    case "MODULO_FILTER_CATEGORY":
      itemNormalized = {
        name: moduleName,
        data: { ...data, orionAlias },
        normalizer: import("./modules-normalizers/tv-card-normalizer"),
      };
      break;
    case "MODULO_SIMPLE_CARD":
      itemNormalized = {
        name: moduleName,
        data: { ...data, orionAlias },
        normalizer: import("./modules-normalizers/tv-card-normalizer"),
      };
      break;
    case "EMBED-CONTAINER": //new
      itemNormalized = {
      name: moduleName,
      data,
      normalizer: import("./modules-normalizers/iframe-normalizer"),
    };

    case "MODULO_PRINCIPAL_CONTRATOS_MANUALES_PRECIOS_SERVICIOS_TELEFONIA":
    case "MODULO_PRINCIPAL_CONTRATOS_MIMOVISTAR":
    case "MODULO_PRINCIPAL_CONTRATOS_MOVISTAR_FUSION":
    case "MODULO_PRINCIPAL_TV_CONTRATOS_MOVISTAR_PLUS":
    case "MODULO_PRINCIPAL_CONTRATOS_INTERNET_BANDA_ANCHA":
    case "MODULO_PRINCIPAL_CONTRATOS_RELOJ_TECUIDA":
    case "MODULO_PRINCIPAL_CONTRATOS_MOVIL_CONDICIONES_GENERALES":
    case "MODULO_PRINCIPAL_CONTRATOS_FIJO":
    case "MODULO_PRINCIPAL_CONTRATOS_PUESTOS_TRABAJO":
    case "MODULO_PRINCIPAL_CONTRATOS_SOLUCIONES_DIGITALES":
    case "MODULO_PRINCIPAL_CONTRATOS_CONDICIONES_ATENCION_CLIENTE":
    case "MODULO_PRINCIPAL_CONTRATOS_CONDICIONES_GENERALES_PARTICULARES_TRADUCIDAS":
    case "MODULO_PRINCIPAL_CONTRATOS_DESESTIMIENTO_CANCELACION_PORTABILIDAD":
    case "MODULO_PRINCIPAL_CONTRATOS_VERIFICACION_IDENTIDAD":
    case "MODULO_PRINCIPAL_CONTRATOS_MOVIL_HISTORICO":
      itemNormalized = {
        name: moduleName,
        data,
        normalizer: import("./modules-normalizers/contratos-normalizer"),
      };       
    break;
    default:
      break;
  }
  return itemNormalized;
};

/**
 * Normaliza los modulos que vienen desde catálogo a una estructura válida
 * @param {Object[]} ModuleList - lista de los modulos  que viene desde catálogo
 * @returns {Object[]} - lista de modulos  normalizados
 */
export const normalizeOrionModule = async (
  response,
  context,
  orionAlias = ""
) => {
    const resNormalized = {};
    let parallelModulesList = [];
    const myModule = (response && response.data) || null;
    resNormalized.alias = response.alias;
    //generamos normalizciones en base a la respuesta de orion
    if (myModule && myModule.fields) {
      const currentModules = { ...myModule.fields };
      const fieldsInfoKeys = Object.keys(currentModules);
      fieldsInfoKeys.forEach(async (fieldsInfoKey) => {
        const currentModule = currentModules[fieldsInfoKey];
        const currentModuleName = currentModule?.name || currentModule[0]?.name;
        if (!currentModuleName) return null;
        const itemNormalized = parallelModules(
          currentModuleName,
          currentModule,
          orionAlias
        );
        if (itemNormalized) {
          parallelModulesList.push(itemNormalized);
        }
      });
    }

    // ejecutamos normalizaciones detectadas
    parallelModulesList = parallelModulesList.map((item) =>
      executeSingleNormalizer(item)
    );
    const frontModules = await Promise.allSettled(parallelModulesList);
    frontModules.forEach(({ status, value }) => {
      const { data, name } = value;
      resNormalized[name] = data;
    });
    return resNormalized;
};

export default normalizeOrionModule;